<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.coupon-search-mobile')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4" title="쿠폰조회">

          <b-row>
            <b-colxx xxs="12" md="4" lg="3" xl="3">
              <div class="form-group has-float-label">
                <v-select v-model="searchKind" :reduce="item=>item.value" label="label" :options="searchOption"/>
                <span>검색유형</span>
              </div>
            </b-colxx>
            <b-colxx xxs="12" md="6" lg="4" xl="4">
              <b-input-group>
                <b-input v-model="searchKeyword" :placeholder="searchPlaceholder" @keyup.enter="onSearch"/>
                <b-input-group-append>
                  <b-button v-show="!searchFlag" @click="onSearch" variant="outline-primary default">
                    {{ $t('button.search') }}
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-colxx>
          </b-row>
          
          <b-row>
            <b-colxx xxs="12">
                  <!-- 주문,상품 -->
                  <div>
                      {{ this.noItem }}
                  </div>
                  <template v-for="(item , i) in items">
                    <div class="mNew-box-ul-div">
                        <ul>
                            <li> 번호 </li>
                            <li  style="text-align: center">
                                {{ item.key }}
                            </li>
                        </ul>
                        <ul>
                            <li> 구매자 </li>
                            <li style="text-align: center">
                                {{ item.buyerName }}
                            </li>
                        </ul>
                        <ul>
                            <li> 전화번호 </li>
                            <li style="text-align: center">
                                {{
                                item.buyerPhone.length == 11 ? '*****' + item.buyerPhone.substr(5, item.buyerPhone.length) : '****' + item.buyerPhone.substr(5, item.buyerPhone.length)
                                }}
                            </li>
                        </ul>
                        <ul>
                            <li> 상품명 </li>
                            <li style="text-align: center">
                                {{ item.coupons[0].goodsName }}
                            </li>
                        </ul>

                        <!-- 옵션 -->
                        <template v-for="(coupon , idx) in item.coupons">
                            <ul>
                                <li> 옵션명 </li>
                                <li style="text-align: center">{{ coupon.optionName }}</li>
                            </ul>
                            <ul>
                                <li> 쿠폰번호 </li>
                                <li style="text-align: center">{{ coupon.itemNo }}</li>
                            </ul>
                            <ul>
                                <li> 유효기간 </li>
                                <li style="text-align: center">
                                    {{
                                        coupon.availableTo >= toDay ? coupon.availableTo.substr(0, 10) + " " + coupon.availableTo.substr(11, 8) : "만료"
                                    }}
                                </li>
                            </ul>
                            <template v-if="coupon.goodsType === 'MoneyCoupon'">
                                <ul>
                                    <li>
                                        <b-button v-if="coupon.usableAmount > 0 &&coupon.itemStatus == 'Available' "
                                            variant="primary" size="sm"
                                            @click="ModalShowAmount(coupon)" class="mb-2">사용
                                        </b-button>
                                        <b-button v-else
                                            variant="primary" class="mb-2 completion" size="sm">사용완료
                                        </b-button>
                                    </li>
                                </ul>
                            </template>
                            <template v-else>
                            <ul v-if="(new Date(coupon.availableTo) > new Date())&& !coupon.consumedDate">
                                <li><b-button class=" mb-2" variant="primary" @click="useMobileCoupon(coupon.itemNo,item.orderNo,coupon.itemStatus,coupon.goodsType)">사용처리</b-button></li>
                            </ul>
                            <ul v-else>
                                <li><b-button class="completion mb-2" variant="primary" >사용완료</b-button></li>
                            </ul>

                            </template>
                            
                        </template>
                        <!-- 옵션 end -->
                    </div>
                  </template>

              <b-pagination
                v-if="lastPage > 1"
                size="sm"
                align="center"
                :total-rows="total"
                :per-page="perPage"
                v-model="currentPage"
              >
                <template v-slot:next-text>
                  <i class="simple-icon-arrow-right"/>
                </template>
                <template v-slot:prev-text>
                  <i class="simple-icon-arrow-left"/>
                </template>
                <template v-slot:first-text>
                  <i class="simple-icon-control-start"/>
                </template>
                <template v-slot:last-text>
                  <i class="simple-icon-control-end"/>
                </template>
              </b-pagination>

            </b-colxx>
          </b-row>

          <!-- 사용내역조회 모달 -->
          <coupon-use-detail ref="modal_coupon_detail" :data="selectedCouponHistory" :goodsType="selectedGoodsType"
                             @process="couponCancel"/>

          <!-- 금액권 사용처리 모달 -->
          <amount-use-detail ref="modal_amount_use_detail" :selectedBalance="selectedBalance" @process="useAmount"/>

        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>


<script>
import {
  mapGetters,
  mapActions,
  mapMutations
} from "vuex";

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {alignTableCenter, currencyFilter} from "../../utils";
import api from '../../constants/api'
import CouponUseDetail from "./components/CouponUseDetail";
import AmountUseDetail from "./components/AmountUseDetail";

export default {
  components: {
    'v-select': vSelect,
    'coupon-use-detail': CouponUseDetail,
    'amount-use-detail': AmountUseDetail
  },
  props: [],
  filters: {...currencyFilter},


  data() {

    return {
      noItem: "",
      toDay: this.$moment().format("YYYY-MM-DD"),
      searchValue: {
        startDate: this.$moment(new Date()).subtract('day', 14).toDate(),
        endDate: this.$moment(new Date()).add('day', 14).toDate(),
        
      },
      searchKind: 'PhoneNumber4',
      searchKeyword: null,
      isLoad: false,
      allCheck: false,
      currentPage: 1,
      perPage: 10,
      lastPage: 0,
      total: 0,
      searchFlag: false,
      searchOption: [
        {label: "전화번호 뒷 4자리", value: "PhoneNumber4"},
        {label: "전화번호", value: "PhoneNumber"},
        {label: "쿠폰번호", value: "ItemNo"}
      ],
      searchPlaceholder: '전화번호 뒷 4자리를 입력해 주세요.',
      selectedGoodsType: null, //선택된쿠폰타입
      selectedCouponHistory: [], //쿠폰 히스토리
      selectedCouponItemNo: '', // 선택된쿠폰번호
      selectedBalance: null, //선택된 잔액
      fields: [
        {key: 'key', label: "번호", ...alignTableCenter},
        {key: 'buyer', label: "구매자", ...alignTableCenter},
        {key: 'phone', label: "전화번호", ...alignTableCenter},
        {key: 'goods_name', label: "상품명", ...alignTableCenter},
        {key: 'option_name', label: "옵션명", ...alignTableCenter},
        {key: 'coupon_serial', label: "쿠폰번호", ...alignTableCenter},
        {key: 'expire_date', label: "유효기간", ...alignTableCenter},
      ],
      items: [],
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName'])
  },


  mounted() {
    if(this.$route.params.searchKeyword !== undefined && this.$route.params.searchKeyword !== "") {
      this.searchKind = this.$route.params.searchKind
      this.searchKeyword = this.$route.params.searchKeyword
      this.searchData()
    }
  },


  watch: {

    searchKind(value) {
      if(value == "ItemNo") {
        this.searchPlaceholder = "쿠폰번호 12자리를 입력해 주세요."
      } else if(value == "PhoneNumber") {
        this.searchPlaceholder = "전화번호를 입력해 주세요."
      } else {
        this.searchPlaceholder = "전화번호 뒷 4자리를 입력해 주세요."
      }
    },

    currentPage(value) {
      this.searchData();
    },

    allCheck(chk) {
      this.items.forEach((v) => {
        v.coupons.forEach((vv) => {
          vv.selected = chk
        })
      })
    },
  },


  methods: {

    //리스트 조회
    searchData() {
      this.isLoad = false
      this.items = []

      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.couponList)

      const params = {
        dateFrom: null,
        dateTo: null,
        pageNumber: this.currentPage - 1,
        pageSize: this.perPage,
        keywordType: this.searchKind,
        keyword: this.searchKeyword
      }
      // console.log(params);

      this.$http.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {
          // 
          let _data = res.data.data
          this.items = _data
          console.log(this.items);
          if(this.items == ""){
            this.noItem = '조회 결과가 없습니다.';
          }else{
            this.noItem = '';
          }
          this.items.forEach((v) => {
            Object.assign(v, {coupons: null})
            v.coupons = v.orderItems.filter(item => item.itemStatus == 'Available' || item.itemStatus == 'Consumed')
          })
          this.items = this.items.filter(item => item.coupons.length > 0)
          for(let i = 0; i < this.items.length; i++) {
            this.items[i].key = i + 1
          }
          this.isLoad = true

        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);

      })
    },

    //조회버튼클릭
    onSearch() {
      if(this.searchKeyword === null || this.searchKeyword === "") {
        alert('검색어를 입력해주세요')
        return false
      } else {
        // this.searchFlag = true;
        this.searchData()
      }
    },

    searchCancel() {
      this.searchKeyword = null;
      this.searchFlag = false;
      this.searchData()
    },

    //금액권 사용처리 모달열기
    ModalShowAmount(coupon) {
      this.selectedBalance = coupon.usableAmount
      this.selectedCouponItemNo = coupon.itemNo

      this.$refs.modal_amount_use_detail.open()
    },


    //금액권 사용처리
    useAmount(item) {
      let orderNo = ''; //선택주문번호
      const itemNo = this.selectedCouponItemNo //선택쿠폰번호

      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.useMoneyCoupon)

      this.items.forEach((v) => {
        v.coupons.forEach(function(value, index) {
          if(value.itemNo == itemNo) {
            orderNo = v.orderNo
          }
        })
      })

      const params =
        {
          memo: "금액권 사용 처리함",
          orderNo: orderNo,
          itemNo: itemNo,
          useAmount: item,
          currencyCode: "KRW"
        }

      // console.log(params);

      this.$http.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {
          // 
          this.$refs.modal_amount_use_detail.modalHide()
          this.searchData()

        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },


    //쿠폰사용처리
    useMobileCoupon(item,oder,itemStatus,goodsType) {
        var data = this.selectUseCoupon(itemStatus,goodsType,item,oder);
        const orders = data.orders         //체크된 옵션의 orderNo, itemNo[]
        if(confirm('사용처리 하시겠습니까?')) {
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.consumeMobileCoupons)
            const params =
            {
                "memo": "사용 처리 함",
                "orders": orders,
            }

            console.log(oder,item)
            this.$http.post(reqURL, params, {
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
            }).then(res => {
            if(res.data.code === "OK") {
                alert('사용처리 되었습니다.');
                this.$refs.modal_amount_use_detail.modalHide()
                this.searchData()


            } else {
                throw 400
            }
            }).catch(err => {
            alert(err.response.data.message);

            })
        }

    },


    selectUseCoupon(itemStatus,goodsType,item,oder) {

      let data = {}
      let selected = true
      let count = 0

      const orders = []

          let flag = false;
          const orderNo = oder //주문번호

          let itemNoArr = []
          // console.log(s,d)
            if(goodsType == "MobileCoupon" && itemStatus == "Available") {
                flag = true
                itemNoArr.push(item)
            }
          if(flag) {
            orders.push({
              "orderNo": orderNo,
              "itemNos": itemNoArr
            })
          }

      data.orders = orders

      console.log(data.orders);
      return data
    },


//사용내역 모달열기
    ModalShowCoupon(goodsType, coupon) {
      this.selectedCouponHistory = []
      this.selectedGoodsType = goodsType


      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.itemUseInfo)
      const params =
        {"itemNo": coupon.itemNo}

      this.$http.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        // ;
        if(res.data.code === "OK") {
          this.ModalShowCouponCallback(goodsType, res.data.data)
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);

      })
    }
    ,


    ModalShowCouponCallback(goodsType, data) {
      let couponHistory = []
      const transactions = data.transactions
      transactions.forEach((v, index) => {

        if(!v.cancelled) {


          const chistory = {
            id: index + 1,
            item_no: data.itemNo,
            transaction_no: v.transactionNo,
            use_date: v.useDate.substr(0, 10) + " " + v.useDate.substr(11, 5),
            use_store: v.storeName,
            manager: v.managerId
          }


          const now = this.$moment(new Date()).toDate()
          const useDate = this.$moment(v.use_date).toDate()

          const newMonth = this.$moment(new Date()).toDate().getDay() - 1
          const useDateMonth = this.$moment(new Date()).toDate().getDay() - 1

          if(goodsType == "MoneyCoupon") { //금액권
            chistory.use_amount = v.useAmount

            if(now.getDate() != useDate.getDate()) {
              //당일이 아닌경우 취소불가
              chistory.cancellable = false
            }

          } else { //쿠폰

            var cancelDate = useDate.setDate(useDate.getDate() + 5)
            if(now > cancelDate) {
              //5일경과시 취소불가
              chistory.cancellable = false
            }
          }


          if(newMonth != useDateMonth) {
            chistory.cancellable = false
          }

          couponHistory.push(chistory)
        }
      })

      this.selectedCouponHistory = couponHistory
      this.$refs.modal_coupon_detail.open()

    }
    ,


//쿠폰 사용처리 취소
    couponCancel(data) {
      let arr = [];


      const cancelUsed = data.cancelUsed;

      cancelUsed.forEach(function(value, index) {
        if(value.selected) {
          const transaction =
            {
              "itemNo": value.item_no,
              "transactionNo": value.transaction_no
            }
          arr.push(transaction)
        }
      })
      //  배열 비었는지 체크
      if(arr.length < 1) {
        alert("쿠폰번호 , 트랜젝션 번호가 없습니다.")
        return

      }


      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.cancelItemUseTransaction)

      const params = {
        "memo": "고객 요청에 의한 처리",
        "transactions": arr
      }

      this.$http.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {
          // 
          this.$refs.modal_coupon_detail.modalHide("CouponUseDetail")
          this.$refs.modal_coupon_detail.modalHide("cancelReason")
          this.searchData()
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);

      })


    }
    ,
  }
}
</script>
